import { Toast } from '@base-ui-components/react/toast'
import { cn } from '../../utils/cn'

export function ToastViewport({ className, ...props }: ToastViewport.Props) {
  return (
    <Toast.Viewport
      className={cn(
        'fixed bottom-[1rem] right-[1rem] top-auto mx-auto flex w-[250px] sm:bottom-[2rem] sm:right-[2rem] sm:w-[300px]',
        className
      )}
      {...props}
    />
  )
}

export namespace ToastViewport {
  export interface Props extends Toast.Viewport.Props {}
}
